const {fr} = require("date-fns/locale");
const { registerLocale, setDefaultLocale } = require("react-datepicker");

registerLocale('fr', fr);
setDefaultLocale('fr');

module.exports = {
  "side_blocks": {
    "fr": [
      "42039819"
    ]
  },
  "display_contact": true,
  "fb_display": false,
  "api_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MjI3MDA0NzQsImV4cCI6MTY1NDIzNjQ3NCwidXNlcm5hbWUiOiIzOSJ9.zwtl76to23UQCkU0YZ2_nXhraXHiTecT01Jm2jCqEi8J6DDWtuU7ZSKIsHcmLkeBq7vp5EDQZgnemlEV9hwp-lLZ6bsTeqju0PmZO2c0I3DxDAKtqr5xHMtDW1qwqXTo6rs0CiAyFpYNkIoWQOK2Um7B19Vf4x5wMHhA76FOLcRTX1KmiJtShv6jekXdGqzusQjxFBgEacZJcHrbA58i0l-s-uyPxNV6i9wm9NWwHiVcziZdeqspNs1gGEkJYpfyqFYsnmUf7T31gGtK0RtOyjvAoPCuWVCMdNi-jgHdbTkMNTJ6IM2flKhR0LcBk-4Vqr9rEJcA8rHOxIPmPffVVy0XBAoLE3Zw5u9jgpv4saONqCVubw1y6Ix9DKfa_gNTbYcrVD9ZGcQph882nNY5hBgAuHt7PuJgNhKGVHrxs2_hHs3KzxW2ZxlpbgB56MfvV85V8qTzHfckAOuV2HKzUGze2bdcaVrLVOJAgziZRymqpkSfSLmc0rCsiAPUb5JVr66GguTiZefoj4A-riya71-HaCovKaZOO6gFT_vJy84LC1qI1M7T64pb-CcPymQDsrH_SvOVFdZNhPzsbDkU8EaPw6J5csO4_OjlGpINOlYkdA5BWQUBgEFBXkZcIGMv9Zmcp-xTewP4j1RGRnY7YeeIoyNw-uv3HfWF6T5fzE0",
  "info_traffic_title": {
    "fr": "Toute l'info trafic"
  },
  "mapbox_token": "pk.eyJ1IjoibWltaXJvc2UyOSIsImEiOiJjbGV3cHhsaGgxMHV2NDNtazAxOGM0MXhrIn0.LieDdLfJevyJ6njBc9-vQg",
  "search_placeholder": {
    "fr": "Recherche"
  },
  "last_news_label": {
    "fr": "Actualités"
  },
  "notifications_service_endpoint": "https://apim.keolis.com/KWP000/notification",
  "date_format": {
    "fr": "dd/MM/yyyy"
  },
  "time_format": {
    "fr": "HH:mm"
  },
  "info_traffic_slug": {
    "fr": "toutes-les-infos-trafic"
  },
  "twitter_display": false,
  "notifications_service_import_file_endpoint": "https://apim.keolis.com/KWP000/file/import",
  "search_title": {
    "fr": "Recherche"
  },
  "website_name": "Roissypole - Gare routière ",
  "news_redirect_label": {
    "fr": "Lire l'actualité"
  },
  "contact_label": {
    "fr": "Renseignements"
  },
  "api_url": "https://api-v2.mobireport.fr",
  "serverless_sendmail_endpoint": "https://apim.keolis.com/dato/send/form",
  "primary_color": {
    "red": 0,
    "green": 170,
    "blue": 195,
    "alpha": 255
  },
  "notifications_service_token": "1142321004f3407b98a95856f9820607",
  "serverless_sendmail_token": "1142321004f3407b98a95856f9820607",
  "info_traffic_detail_slug": {
    "fr": "Détail de l'info trafic"
  },
  "search_button_label": {
    "fr": "Rechercher"
  },
  "contact_phone_number": {
    "fr": "01 48 62 38 33"
  },
  "alt_text": {
    "fr": "Renseignements : 01 48 62 38 33"
  },
  "no_search_label": {
    "fr": "Veuillez saisir des termes et valider pour lancer la recherche"
  },
  "gradient_primary_color": {
    "red": 0,
    "green": 95,
    "blue": 125,
    "alpha": 255
  },
  "info_traffic_content_title": {
    "fr": "L'information trafic"
  },
  "search_in_progress_label": {
    "fr": "Recherche en cours..."
  },
  "search_icon_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 1
  },
  "redirection_button_text": {
    "fr": "+ D'INFOS"
  },
  "gradient_button_color": {
    "red": 0,
    "green": 95,
    "blue": 125,
    "alpha": 255
  },
  "search_no_results_label": {
    "fr": "Il n'y a aucun résultat pour cette recherche"
  },
  "active_button_text_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 255
  },
  "search_error_label": {
    "fr": "Une erreur s'est produite, veuillez réessayer dans quelques minutes"
  },
  "secondary_color": {
    "red": 250,
    "green": 250,
    "blue": 250,
    "alpha": 255
  },
  "search_token": "1e29ca9bf61c12a68f70ae8618dbb1",
  "subsidiary_logo": {
    "path": "/56515/1693413061-logoibus.png",
    "format": "png",
    "size": 9910,
    "alt": "Logo Roissy Pôle",
    "title": "Roissy Pôle",
    "width": 615,
    "height": 301
  },
  "back_to_home_title": {
    "fr": "Roissypôle – revenir à la page d'accueil"
  },
  "language_selector_title": {
    "fr": "Changer la langue"
  },
  "piano_site_id": "639218",
  "google_tag_manager_id": "GTM-K3J68ZS",
  "google_analytics_key": "",
  "didomi_api_key": "2127e597-3d3f-4aa2-9727-c8126f86298c",
  "actistat_key": "",
  "loader": {
    "path": "/56515/1693503628-loader-bleu.gif",
    "format": "gif",
    "size": 678002,
    "alt": "Page en chargement, veuillez patientez s'il vous plaît",
    "title": "Page en chargement",
    "width": 1080,
    "height": 1080
  },
  "api_url_get_lines_endpoint": "/public/line",
  "api_url_user_registration_endpoint": "/public/customer",
  "scripts": [],
  "form_captcha_key": "6Lcd1DMjAAAAAEsHVSyCqBSA_c8IBpjJStjgY_pH",
  "updated_at": "2026-04-08T15:35:20.777+02:00",
  "created_at": "2020-12-29T15:46:21.809+01:00",
  "locale": "fr",
  "locales": [
    "fr"
  ],
  "siteUrl": "https://www.roissypole.info/",
  "readOnlyApi": "661e575585fe8dd677b158e1501b93"
}